import { getOneXpExperiments } from 'src/universal/redux/oneXp';
import {
  getPageFirstCardData,
  getExperimentalPageData
} from 'src/universal/redux/page';
import { createSelector } from 'reselect';

export const isG157Variant = createSelector(
  [getOneXpExperiments, getPageFirstCardData],
  (oneXpExperiments, currCard) => {
    /*
    US5591257:
    (1) We are excluding BPlat card from participating g157 test.
    (2) Per Wade, we are to include the BPlat back if g157 wins.
    (3) Please ask William to do the rollout if g157 wins because there are
        certain features must be enabled on the BusinessValueTilesCarousel side.
    */
    if (currCard?.shortName === 'platinum') {
      return false;
    }

    return (
      oneXpExperiments['GCS-157-PDP-Mobile-Horizontal-Scroll']?.dimensions[0]
        ?.variant === 'variant-1'
    );
  }
);

export const getCombinedG157Data = createSelector(
  [isG157Variant, getExperimentalPageData, getPageFirstCardData],
  (g157Variant, { g157MobileHorizontalScroll }, currCard) => {
    return {
      isG157Variant: g157Variant,
      shortName: currCard.shortName,
      staticG157Data: g157MobileHorizontalScroll
    };
  }
);
